import React, { PureComponent } from 'react';
import { Toast, InputItem, TextareaItem } from 'antd-mobile';
import styles from './index.less';
import './index.less';

export const SectionHeader = ({ children }) => {
  return <div className={styles['sn-section-header']}>{children}</div>;
};

export const CustomLoading = (
  text = 'Loading......',
  duration = 0,
  loadingIcon = require('@/assets/images/auth/toast_loading.svg')
) =>
  Toast.info(
    <div className={styles['custom-loading']}>
      <img src={loadingIcon} alt="loading-icon" />
      <p>{text}</p>
    </div>,
    duration
  );

export class ErrorInputItem extends PureComponent {
  onErrorClick = errors => {
    Toast.fail(errors[0], 2, null, false);
  };

  render() {
    const { name, type, rules, onChange, defaultValue, form, ...otherProps } = this.props;
    const { getFieldProps, getFieldError } = form;
    const errors = getFieldError(name);

    return (
      <InputItem
        type={type || 'text'}
        error={errors}
        onErrorClick={() => {
          this.onErrorClick(errors);
        }}
        labelNumber={6}
        spellCheck={false}
        placeholder="请输入"
        {...otherProps}
        {...getFieldProps(name, {
          rules,
          onChange,
          initialValue: defaultValue,
        })}
      />
    );
  }
}

export class ErrorTextarea extends PureComponent {
  onErrorClick = errors => {
    Toast.info(errors[0], 2, null, false);
  };

  render() {
    const { name, children, type, rules, onChange, defaultValue, form, ...otherProps } = this.props;
    const { getFieldProps, getFieldError } = form;
    const errors = getFieldError(name);

    return (
      <>
        <div
          className={`${styles['am-list-item']} ${styles['am-item-flex']} ${styles['am-list-item-middle']}`}
        >
          <div className={styles['am-list-content']} style={{ color: '#000' }}>
            拨号信息
          </div>
        </div>
        <div
          className={`${styles['am-list-item']} ${styles['am-item-flex']} ${styles['am-list-item-middle']}`}
        >
          <div
            className={styles['am-list-content']}
            style={{ fontSize: '.24rem', lineHeight: '1.6' }}
          >
            {children}
          </div>
        </div>
        <TextareaItem
          error={errors}
          onErrorClick={() => {
            this.onErrorClick(errors);
          }}
          placeholder="请输入"
          {...otherProps}
          {...getFieldProps(name, {
            rules,
            onChange,
            initialValue: defaultValue,
          })}
        />
      </>
    );
  }
}

export const Checkbox = ({ id, children, onChange, style, checked = false }) => {
  return (
    <div className={styles['checkbox-wrapper']} style={style}>
      <label className={styles['checkbox']} htmlFor={id}>
        <input
          id={id}
          type="checkbox"
          onChange={e => onChange(e.target.checked)}
          checked={checked}
        />
        <span className={styles['check-mod']}></span>
      </label>
      <span className={styles['checkbox-content']}>{children}</span>
    </div>
  );
};
